<script>
  /** @type {{ children: import('svelte').Snippet }} */
  const { children } = $props();
</script>

<div class="key-value-set">
  {@render children?.()}
</div>

<style>
  .key-value-set {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-4);
  }
</style>
